import type { FunctionComponent, SVGProps } from 'react';

export type IconComponent = FunctionComponent<SVGProps<SVGSVGElement>>;

/**
 * Unwraps a CommonJS icon from @tdcerhverv/parrotfish.
 *
 * The icons are compiled CommonJS: `exports.__esModule = true; exports.default = SvgExpandDown`.
 * The Vite dev server pre-bundles that as `export default require_ExpandDown()`, which hands back
 * the whole exports object rather than the function on it — so a plain default import gives
 * `{ __esModule: true, default: f }` and rendering it fails with "Element type is invalid:
 * expected a string or a class/function but got: object".
 *
 * The production build and the test runner unwrap it correctly, so the mismatch shows up only
 * when running `npm run dev` — which is the worst way for it to show up, because the build stays
 * green. Normalising here removes the dependency on which bundler path is in play.
 */
export function icon(imported: IconComponent): IconComponent {
  if (typeof imported === 'function') {
    return imported;
  }

  const wrapped = (imported as { default?: IconComponent }).default;

  if (typeof wrapped === 'function') {
    return wrapped;
  }

  throw new TypeError(
    'A parrotfish icon resolved to neither a component nor a module wrapping one. ' +
      'The package layout has probably changed.',
  );
}
